import { createFileRoute } from "@tanstack/react-router";
import { DataPanel } from "../../components/Settings/Data/DataPanel";
import { useActiveOrganization } from "../../hooks/useActiveOrganization";

export const Route = createFileRoute("/settings/data")({
	component: DataRoute,
});

function DataRoute() {
	const { activeOrganization } = useActiveOrganization();
	const isAdmin = activeOrganization?.role === "ADMIN";
	return <DataPanel isAdmin={isAdmin} />;
}
